import { DATASET } from '../../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { fromJS } from 'immutable';
import { parseDynamicFilterFamilyId, testDynamicFilterFamily } from '../../../filterQueryFormat/DynamicFilterFamilies';
import { toDSFieldRecord } from '../../../filterQueryFormat/DSFieldRecord/toDSFieldRecord';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
export class DatasetAdapterConfig extends HttpAdapterConfig {
  constructor(...args) {
    super(...args);
    this.performanceTrackingKey = 'DatasetAdapterConfig';
    this.isAssetFamilySupported = assetFamily => {
      return testDynamicFilterFamily(DATASET, assetFamily);
    };
  }
  getCacheKey(assetFamily) {
    return `DATASET_${assetFamily}`;
  }
  fetchData(httpClient, assetFamily) {
    const objectTypeId = parseDynamicFilterFamilyId(DATASET, assetFamily);
    return httpClient(`sql-reporting/v1/datasets/objectTypeIds/${objectTypeId}`);
  }
  formatData(response, assetFamily) {
    const referenceRecords = response.map(option => ReferenceRecord({
      id: String(option.id),
      label: option.name,
      referencedObject: fromJS(option)
    }));
    return toDSFieldRecord(referenceRecords, assetFamily);
  }
}
export default Adapter.makeFromConfig(DatasetAdapterConfig);